import { Component, OnInit, Input } from '@angular/core';
import { YoyakuService } from "../service/yoyaku.service";
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'yoyaku-list-view.component',
  templateUrl: './yoyaku-list-view.component.html',
  styleUrls: ['yoyaku-list-view.component.css']
})

export class YoyakuListViewComponent {
  @Input() yoyakuData;

  constructor(
    public activeModal: NgbActiveModal,
    private yoyakuService: YoyakuService,
  ) {}
  personData:any =[];
  count:number = null;
  isLoaded: boolean = false;
  ret:any={
    status:"",
  }
  ngOnInit(): void {
    this.getPersonList(this.yoyakuData.m_yoyaku_id);
  };
  personYoyakuCount(): void {
    if(this.personData == undefined){
      this.count = 0;
    } else {
      this.count = this.personData.length;
    }
  };
  getPersonList(mYoyakuId: number) {
    this.yoyakuService.getYoyakuPerson(mYoyakuId).subscribe(
      (res: Response) => {
        if (res["fuel_status"] == "OK") {
          this.personData = res["fuel_results"]["person_list"];
          this.isLoaded = true;
        } else if (res["fuel_status"] == "NG") {
          this.ret.status = 'NG';
          this.activeModal.close(this.ret);
        } else {
          this.activeModal.close(this.ret);
        }
      },
      (error) => {
        //
      }
    );
  }
  modalCloseOK() {
    this.ret.status = 'OK';
    this.activeModal.close(this.ret);
  }
  modalCloseCancel(){
    this.ret.status = 'Cancel';
    this.activeModal.close(this.ret);
  }
}



// WEBPACK FOOTER //
// ./src/app/a2104-yoyaku-list/yoyaku-list-view.component.ts